import "core-js/modules/es.object.assign";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/*
 * Copyright (c) 2020 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
import React, { useEffect, useContext, useRef } from 'react';
import WFMasthead from 'wfui-digital-core/es/WFMasthead';
import PageContext from 'wfui-digital-core/es/PageContext';
import WFMastheadNavigationMenu from '../wf-masthead-navigation-menu/WFMastheadNavigationMenu';
import navigate from '../../lib/navigation/navigate';
export default (function (props) {
  var mastheadRef = useRef();

  var _useContext = useContext(PageContext),
      setContainerRef = _useContext.setContainerRef;

  useEffect(function () {
    setContainerRef('masthead')(mastheadRef.current);
  }, [setContainerRef]);
  return /*#__PURE__*/React.createElement(WFMasthead, _extends({
    navigate: navigate,
    navigationMenu: WFMastheadNavigationMenu,
    ref: mastheadRef
  }, props));
});